module.exports = __webpack_public_path__ + "img/168x168-4.f100b94f.png";